export enum ActivityFilterEnum {
  ActivityWithBookings = "activityWithBookings",
  ActivityFullyBooked = "activityFullyBooked",
  ActivityWithAvailabilities = "activityWithAvailabilities",
}

export const AGENDA_LOCAL_STORAGE_KEY = "agenda";
